export class ValidationPatterns {

  /**
   * Pattern for email validation
   */
  public static readonly email = /^(([^<>()\[\]\\.,'`"|!%=+?&*^$#/;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+")){3,}@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  /**
   * Pattern for password validation
   */
  public static readonly password = /.{8,}/;

  /**
   * Pattern for phone number validation
   */
  public  static readonly phoneNumber = /(^[+]?[0-9]+)$/;

  /**
   * Pattern for cvv validation
   */
  public static readonly cvv = /^[0-9]{3,4}$/;

  /**
   * Pattern only numbers
   */
  public static readonly numbers = '^[0-9]*$';

  /**
   * Pattern only letters
   */
  public static readonly letters = /^[A-Za-z]+$/;

  /**
   * Pattern for creditCard validation
   */
  public static readonly creditCard = /^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/;

  /**
   * Pattern for date of birth validation
   */
  public static readonly dateOfBirth = /^(0[1-9]|[12][0-9]|3[01])[/](0[1-9]|1[012])[/](19(18|19|[2-9][0-9])|20\d\d)$/;

  /**
   * Pattern for all languages letters and numbers without spaces
   */
  public static readonly lettersAndNumbers = /^[一-龠ぁ-ゔァ-ヴーA-Za-zwàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð0-9]+$/;

  /**
   * Pattern for canadian postal code
   */
  public static readonly canadianPostalCode = /(([A-Z][0-9][A-Z])|([a-z][0-9][a-z])) (([0-9][A-Z][0-9])|([0-9][a-z][0-9]))/;
  public static readonly auPostalCode = /^\d{4}$/;

  /**
   * Pattern with no spaces and symbols
   */
  public static readonly noSpacesAndSymbols = /^[^\W_]+$/;

  /**
   * Use letters without numbers or special characters. Allowed symbols: (') (-) (.) and spaces
   */
  public static readonly lettersWithoutNumbers = /^[A-Za-z\s'\-.]+$/;

  public static readonly noSpaces = /^\S+$/;
}
